import { call, put, takeLatest } from "@redux-saga/core/effects";
import { ChargingStationConstant } from "./chargingStationConstant";
import { chargingStationApi } from "./chargingStationApi";
import { chargingStationParser } from "./chargingStationParser";

function* getChargingStationList({payload}) {

  let { from_date, to_date, search_term, page, limit,sort,network } = payload;
  try {
    yield put({ type: ChargingStationConstant.CHARGING_STATION_REQUEST });

    const res = yield call(chargingStationApi.getChargingStations,{
      to_date,
      from_date,
      sort,
      search_term,
      page,
      limit,
      network,
    });

    const payload = chargingStationParser.chargingStation(res);

    yield put({
      type: ChargingStationConstant.CHARGING_STATION_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_RESPONSE,
      payload: [],
    });
  }
}
function* postChargingStationsBulkData({payload}) {
  try {
    yield put({
      type: ChargingStationConstant.POST_CHARGING_STATION_BULK_REQUEST,
    });
    const formData = yield call(chargingStationApi.postBulkData);

    yield put({
      type: ChargingStationConstant.POST_CHARGING_STATION_BULK_RESPONSE,
      payload: formData,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: ChargingStationConstant.POST_CHARGING_STATION_BULK_RESPONSE,
      payload: [],
    });
  }
}
function* deleteChargingStation({ payload }) {
  const { id } = payload;
  try {
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DELETE_REQUEST,
    });
    const res = yield call(chargingStationApi.deleteChargingStation, { id });
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DELETE_RESPONSE,
      payload: res,
    });
  } catch (e) {
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DELETE_RESPONSE,
      payload: {},
    });
  }
}

function* detailChargingStation({ payload }) {
  const { id } = payload;
  try {
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DETAIL_REQUEST,
    });
    const res = yield call(chargingStationApi.ChargingStationDetail, { id });

    const payload = chargingStationParser.chargingStationDetail(res);

    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DETAIL_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_DETAIL_RESPONSE,
      payload: {},
    });
  }
}

function* getChargingPointList(id) {
  let { station_id } = id;
  try {
    yield put({ type: ChargingStationConstant.GET_CHARGING_POINT_REQUEST });
    const res = yield call(chargingStationApi.getChargingPoint, station_id);
    const payload = chargingStationParser.chargingPoint(res);
    yield put({
      type: ChargingStationConstant.GET_CHARGING_POINT_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.GET_CHARGING_POINT_RESPONSE,
      payload: {},
    });
  }
}

function* deleteChargingConnector({ payload }) {
  const { id } = payload;

  try {
    yield put({
      type: ChargingStationConstant.DELETE_CHARGING_CONNECTOR_REQUEST,
    });
    const res = yield call(chargingStationApi.DeleteChargingConnectorApi, {
      id,
    });
    const payload = res;
    yield put({
      type: ChargingStationConstant.DELETE_CHARGING_CONNECTOR_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.DELETE_CHARGING_CONNECTOR_RESPONSE,
      payload: [],
    });
  }
}

// select vendor

function* getSelectVendorWise() {
  try {
    yield put({ type: ChargingStationConstant.GET_VENDOR_SELECT_WISE_REQUEST });

    const res = yield call(chargingStationApi.getVendorSelectWiseApi);


    const payload = res;

    yield put({
      type: ChargingStationConstant.GET_VENDOR_SELECT_WISE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.GET_VENDOR_SELECT_WISE_RESPONSE,
      payload: [],
    });
  }
}

function* AddChargingTableEnableDisable({ payload }) {
  const { id, status } = payload;

  try {
    yield put({
      type: ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_REQUEST,
    });
    const res = yield call(
      chargingStationApi.AddChargingTableEnableDisableApi,
      { id, status }
    );
    const payload = res;
    yield put({
      type: ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    yield put({
      type: ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_RESPONSE,
      payload: [],
    });
  }
}
//csc

function* getChargingStationCount() {
  try {
    yield put({ type: ChargingStationConstant.CHARGING_STATION_COUNT_REQUEST });

    const res = yield call(chargingStationApi.ApigetChargingStationCount);


    const payload = res;

    yield put({
      type: ChargingStationConstant.CHARGING_STATION_COUNT_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_COUNT_RESPONSE,
      payload: [],
    });
  }
}
function* getChargingRequest() {
  try {
    yield put({ type: ChargingStationConstant.CHARGING_SEEALLRES_REQUEST });

    const res = yield call(chargingStationApi.getChargingStationSeeAllRequest);

    // eslint-disable-next-line no-unused-vars
    const payload = chargingStationParser.chargingStationSellAllRequest(res);

    yield put({
      type: ChargingStationConstant.CHARGING_SEEALLRES_RESPONSE,
      payload: res,
    });
  } catch (e) {
    console.log(e);
    yield put({
      type: ChargingStationConstant.CHARGING_SEEALLRES_RESPONSE,
      payload: [],
    });
  }
}
function* getChargingConnectorDropdown() {
  try {
    yield put({ type: ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_REQUEST });

    const res = yield call(chargingStationApi.getConnectotDropdown);

    const payload = chargingStationParser.chargingConnectorDropdown(res);

    yield put({
      type: ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_RESPONSE,
      payload: payload,
    });
  } catch (e) { 
    console.log(e);
    yield put({
      type: ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_RESPONSE,
      payload: [],
    });
  }
}

function* getChargingNetworkDropdown() {
  try {
    yield put({ type: ChargingStationConstant.CHARGING_STATION_NETWORK_REQUEST });

    const res = yield call(chargingStationApi.getStationNetworkApi);

    const payload = chargingStationParser.chargingNetworkDropdown(res);

    yield put({
      type: ChargingStationConstant.CHARGING_STATION_NETWORK_RESPONSE,
      payload: payload,
    });
  } catch (e) { 
    console.log(e);
    yield put({
      type: ChargingStationConstant.CHARGING_STATION_NETWORK_RESPONSE,
      payload: [],
    });
  }
}

export function* registerChargingStationSaga() {
  yield takeLatest(
    ChargingStationConstant.CHARGING_STATION_SAGA,
    getChargingStationList
  );
  yield takeLatest(
    ChargingStationConstant.GET_CHARGING_POINT_SAGA,
    getChargingPointList
  );
  yield takeLatest(
    ChargingStationConstant.CHARGING_STATION_DELETE_SAGA,
    deleteChargingStation
  );
  yield takeLatest(
    ChargingStationConstant.DELETE_CHARGING_CONNECTOR_SAGA,
    deleteChargingConnector
  );
  yield takeLatest(
    ChargingStationConstant.CHARGING_STATION_DETAIL_SAGA,
    detailChargingStation
  );
  yield takeLatest(
    ChargingStationConstant.GET_VENDOR_SELECT_WISE_SAGA,
    getSelectVendorWise
  );
  yield takeLatest(
    ChargingStationConstant.ENABLE_DESABLE_CHARGING_TABLE_SAGA,
    AddChargingTableEnableDisable
  );
  yield takeLatest(
    ChargingStationConstant.CHARGING_STATION_COUNT_SAGA,
    getChargingStationCount
  );
  yield takeLatest(
    ChargingStationConstant.CHARGING_SEEALLRES_SAGA,
    getChargingRequest
  );
  yield takeLatest(
    ChargingStationConstant.GET_CHARGER_CONNECTOR_DROPDOWN_SAGE,
    getChargingConnectorDropdown
  );yield takeLatest(
    ChargingStationConstant.POST_CHARGING_STATION_BULK_SAGA,
    postChargingStationsBulkData
  );yield takeLatest(
    ChargingStationConstant.CHARGING_STATION_NETWORK_SAGA,
    getChargingNetworkDropdown
  );
}
